export enum ProductGroupEnum {
  All = 0,
  DMA = 1,
  ICL = 2,
  None = 99
}

export default interface User {
  login: string;
  name: string;
  company: string;
  site: string;
  position: string;
  email: string;
  accessLevel: number;
  containerName: string;
  iclProductGroup: ProductGroupEnum | undefined;
}
